import { useTanks } from '@api/useTanks'
import { Vertical } from '@gravitate-js/excalibrr'
import { Col, Row, Spin } from 'antd'
import React, { useState } from 'react'

import { ProductInfo } from './ProductInfo'
import { TankInfo } from './TankInfo/TankInfo'
import { TankSizing } from './TankSizing/TankSizing'

export function RowExpanded({ data, tankMetadata, api }) {
  const { useTankDetailsQuery } = useTanks()
  const { data: tankDetailData, isSuccess } = useTankDetailsQuery(data)
  const [loading, setLoading] = useState(false)

  if (!isSuccess || !tankDetailData)
    return (
      <Vertical horizontalCenter verticalCenter style={{ minHeight: 300 }}>
        <Spin />
      </Vertical>
    )

  return (
    <Row className='ml-2 mb-5'>
      <Col span={6} className='p-2'>
        <TankInfo tank={tankDetailData} loading={loading} setLoading={setLoading} />
      </Col>
      <Col span={5} className='p-2'>
        <ProductInfo tank={tankDetailData} />
      </Col>
      <Col span={13} className='p-2'>
        <TankSizing
          tank={tankDetailData}
          gridAPI={api}
          metadata={tankMetadata}
          loading={loading}
          setLoading={setLoading}
        />
      </Col>
    </Row>
  )
}
